module.exports = __webpack_public_path__ + "img/signup-school-type.53cc95b2.svg";